class MembershipTier {
  constructor(element) {
    this.element = element;
    this.bindInputs();
  }

  get htmlElement() {
    return this.element;
  }

  get ordinal() {
    return this.element.dataset.ordinal;
  }

  get name() {
    return this.element.querySelector('input[name$="[name]"]').value;
  }

  get nameInput() {
    return this.element.querySelector('input[name$="[name]"]');
  }

  bindInputs() {
    // Anytime we adjust the name of this membership tier, we need to also adjust the names
    // of the visibility pills for this tier listed on the fields.
    this.nameInput.addEventListener('input', (e) => {
      document.querySelectorAll(`[data-tier-ordinal="${this.ordinal}"]`).forEach(
        (div) => {
          div.querySelector('[data-role="name"]').innerHTML = e.target.value;
          div.querySelector('input').value = e.target.value;
        }
      );
    });
  }
}

export { MembershipTier };
